var map = {
	"./candlelight-back.png": "Hcvy",
	"./dark-back.png": "T9ua",
	"./khalasPay-back.png": "TG91",
	"./lavender-back.png": "tRmL",
	"./night-blue-back.png": "ThLT",
	"./orange-back.png": "oMEL",
	"./regular-back.png": "wVjR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W1d2";


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\-back\.png$
// module id = W1d2
// module chunks = 9